module.exports = __webpack_public_path__ + "img/firefox_step_4.0148f9e9.jpg";